<template>
  <div class="info">
    <div class="infoTop">
      <i class="iconfont icon-changfangxingbiaoqian"></i>
      <!--  市场销售:-->
      {{$t('fangTXQ_market_sales')}}
    </div>
    <ul class="infoContent twocol">
      <!--  销售:-->
      <li>{{$t('fangTXQ_salesman')}}:
        <span class="infoVal">{{masterBase.salesman}}</span>
      </li>
      <!--  预订类型:-->
      <li>{{$t('fangTXQ_rsvTypeName')}}:
        <span class="infoVal">{{masterBase.rsvTypeName}}</span>
      </li>
      <!--  市场:-->
      <li>{{$t('fangTXQ_market')}}:
        <span class="infoVal">{{masterBase.market}}</span>
      </li>
      <!--  来源:-->
      <li class="p100">{{$t('fangTXQ_src')}}:
        <span class="infoVal">{{masterBase.src}}</span>
      </li>
      <!--  佣金码:-->
      <li class="p100">{{$t('fangTXQ_cmscode')}}:
        <span class="infoVal">{{masterBase.cmscode}}</span>
      </li>
      <!--  渠道:-->
      <li>{{$t('fangTXQ_channel')}}:
        <span class="infoVal">{{masterBase.channel}}</span>
      </li>
      <!--  付款码:-->
      <li>{{$t('fangTXQ_payCode')}}:
        <span class="infoVal">{{masterBase.payCode}}</span>
      </li>
      <!--  中央预订号:-->
      <li class="p100">{{$t('fangTXQ_crsNo')}}:
        <span class="infoVal">{{masterBase.crsNo}}</span>
      </li>
      <!--  包价:-->
      <li class="p100">{{$t('fangTXQ_packagesDis')}}:
        <span class="infoVal">{{masterBase.packagesDis}}</span>
      </li>
      <li>{{$t('fangTXQ_creditMan')}}:
        <span class="infoVal">{{masterBase.creditMan}}</span>
      </li>
      <li class="p100">{{$t('fangTXQ_otaRsvNo')}}:
        <span class="infoVal"
              style="color:red">{{masterBase.otaRsvNo}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    props: {
      masterBase: {
        type: Object,
        default: {}
      }
    }
  };
</script>



// WEBPACK FOOTER //
// marketInfo.vue?44e66614